'use client';

import { Details } from '@cc-shopping/ui/primitives/Details';
import { palette } from '@cc-shopping/ui/theme';
import { Typography } from '@mui/material';
import { useState } from 'react';

export function MoreAuthorsAccordion({
  numberOfAdditionalAuthors,
}: {
  numberOfAdditionalAuthors: number;
}) {
  const [isExpanded, setIsExpanded] = useState(false);
  if (numberOfAdditionalAuthors === 0) {
    return null;
  }
  return (
    <Details
      variant="simple"
      SummaryComponent={
        <>
          <Typography
            variant="notesSmall"
            sx={{ fontWeight: 500 }}
          >{`+ ${numberOfAdditionalAuthors} more`}</Typography>
          <span
            className="mask-icon mask-icon-expand-more expand-icon"
            style={{ width: '18px', height: '18px', backgroundColor: palette.common.white }}
          />
        </>
      }
      detailsProps={{
        onToggle: ({ newState }) => setIsExpanded(newState === 'open'),
      }}
      summaryComponentProps={{
        'data-testid': 'mobile-author-byline-summary',
        'aria-controls': 'mobile-author-byline-extra-authors',
        'aria-expanded': isExpanded,
        id: 'mobile-author-byline-summary',
        sx: {
          marginLeft: 2,
          width: 'fit-content',
          height: 'fit-content',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          '&:hover': {
            outline: '1px solid',
            outlineColor: 'lime.tintLP2',
            outlineOffset: '4px',
          },
        },
      }}
    />
  );
}
